/**
 * Generate a random password and optionally set it to a form field.
 * @param {number} length - The desired length of the password.
 * @param {boolean} includeSpecialChars - Whether to include special characters.
 * @param {Function} [setValue] - Optional function to set the password in a form field.
 * @param {string} [fieldName] - The name of the form field to set the password.
 * @returns {string} - The generated password.
 */
export const generatePassword = ( length = 8, includeSpecialChars = true, setValue = null, fieldName = ""
) => {
  const upperCaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerCaseChars = "abcdefghijklmnopqrstuvwxyz";
  const digitChars = "0123456789";
  // const specialChars = "!@#$%^&*()_+[]{}|;:,.<>?";
  const specialChars = "!@#$%^&*";

  const getRandomChar = (chars) => chars.charAt(Math.floor(Math.random() * chars.length));

  let password = "";
  // Ensure all required conditions
 password += getRandomChar(upperCaseChars);
 password += getRandomChar(lowerCaseChars);
 password += getRandomChar(digitChars);
 password += getRandomChar(specialChars);

  
  const allChars = upperCaseChars + lowerCaseChars + digitChars + (includeSpecialChars ? specialChars : "");

    // Ensure the password length is at least the minimum length
    while (password.length < length) {
      password += getRandomChar(allChars);
    }

    // If setValue is provided, use it to update the form field
    if (setValue && fieldName) {
      setValue(fieldName, password);
    }

    return password;
  };

  